
export default {
  data() {
    return {
      userHasScrolledDown: false,
      isMounted: false,
    };
  },
  computed: {
    showScrollToTop() {
      // jl: checks if any external components want to hide the 'scroll to top' button
      return this.userHasScrolledDown && !this.$store.state?.scrollToTop?.hideScrollToTop;
    },
  },
  mounted() {
    this.isMounted = true;
    window.addEventListener('scroll', this.windowScrollEvent);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.windowScrollEvent);
  },
  methods: {
    scrollToTop() {
      if (this.isMounted) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    },
    windowScrollEvent() {
      if (this.isMounted) {
        this.userHasScrolledDown = (window.scrollY >= window.screen.height);
      }
    },
  },
};
